<div class="burger-menu-container card flex justify-center">
    <p-listbox [options]="tabs" optionLabel="name" class="list-box" />
</div>